module.exports = __webpack_public_path__ + "../resources/img/ic_module_landscape.56c2e64f.svg";